import { handleActions } from "redux-actions"
import {
  RE_GENERATE_SUMMARY_INIT,
  RE_GENERATE_SUMMARY_DONE,
  RE_GENERATE_SUMMARY_FAIL,
  TOGGLE_CANDIDATE_DETAILS_MODAL,
  FETCH_CANDIDATE_DETAILS_INIT,
  FETCH_CANDIDATE_DETAILS_DONE,
  FETCH_CANDIDATE_DETAILS_FAIL,
  SET_CANDIDATE_MAPPING_DATA_DONE,
  UPDATE_LOGO_INIT,
  UPDATE_LOGO_DONE,
  UPDATE_LOGO_FAIL,
  DELETE_LOGO_DONE,
} from "../actions/actions"
import $ from "jquery"
import _ from "underscore"

const candidateDetails = handleActions(
  {
    [SET_CANDIDATE_MAPPING_DATA_DONE]: (state, action) => {
      let newState = $.extend(true, {}, state)
      let mappingData = {}
      if (!_.isEmpty(action.payload)) {
        _.map(_.keys(action.payload), (id) => {
          mappingData[id] = action.payload[id]?.verification_fields || []
        })
      }
      newState.mappingData = mappingData
      return newState
    },

    [TOGGLE_CANDIDATE_DETAILS_MODAL]: (state, action) => {
      let newState = $.extend(true, {}, state)
      const {
        isOpen,
        resumeId,
        builderId,
        showEditText = false,
      } = action.payload
      newState.isOpen = isOpen
      newState.resumeId = resumeId
      newState.builderId = builderId
      newState.showEditText = showEditText
      if (!isOpen) {
        newState.data = {}
        newState.resumeId = null
        newState.builderId = null
        newState.showEditText = false
        newState.logosUpdated = false
      }
      return newState
    },

    [FETCH_CANDIDATE_DETAILS_INIT]: (state, action) => {
      return {
        ...state,
        fetching: true,
      }
    },

    [FETCH_CANDIDATE_DETAILS_DONE]: (state, action) => {
      let newState = $.extend(true, {}, state)
      const { data } = action.payload

      newState.fetching = false
      newState.data = data.params || {}
      let logosData = newState.data.images?.logos
      _.map(logosData, logo => {
        logo.uploading = false
        if (!logo.path && !logo.url) logo.url = null
      })
      newState.reGenerationsLeft = data.reGenerationsLeft || 0
      return newState
    },

    [UPDATE_LOGO_INIT]: (state, action) => {
      let newState = $.extend(true, {}, state)
      let company = action.payload,
        imageData = newState.data?.images?.logos || []
      if (!_.isEmpty(imageData[company])) {
        imageData[company]["uploading"] = true
      }
      newState.logosUpdated = true
      return newState
    },

    [UPDATE_LOGO_DONE]: (state, action) => {
      let newState = $.extend(true, {}, state)
      let { response, company } = action.payload,
        imageData = newState.data?.images?.logos || []
      if (!_.isEmpty(imageData[company])) {
        imageData[company]["uploading"] = false
        imageData[company]["path"] = response.logoS3Path || ""
        imageData[company]["url"] = response.url
      }
      newState.logosUpdated = true
      return newState
    },

    [DELETE_LOGO_DONE]: (state, action) => {
      let newState = $.extend(true, {}, state)
      const { company } = action.payload,
        imageData = newState.data?.images?.logos || []
      if (!_.isEmpty(imageData[company])) {
        imageData[company]["path"] = ""
        imageData[company]["url"] = null
        imageData[company]["uploading"] = false
      }
      newState.logosUpdated = true
      return newState
    },

    [UPDATE_LOGO_FAIL]: (state, action) => {
      let newState = $.extend(true, {}, state)
      let company = action.payload,
        imageData = newState.data?.images?.logos || []
      if (!_.isEmpty(imageData[company])) {
        imageData[company]["uploading"] = false
      }
      newState.logosUpdated = true
      return newState
    },

    [FETCH_CANDIDATE_DETAILS_FAIL]: (state, action) => {
      return {
        ...state,
        fetching: false,
      }
    },

    [RE_GENERATE_SUMMARY_INIT]: (state, action) => {
      return {
        ...state,
        summaryFetching: true,
        fetchedOnce: false,
      }
    },

    [RE_GENERATE_SUMMARY_DONE]: (state, action) => {
      return {
        ...state,
        summaryFetching: false,
        summaryFetched: true,
        summary: action.payload?.summary || "",
        reGenerationsLeft:
          action.payload?.reGenerationsLeft || state.reGenerationsLeft - 1,
      }
    },

    [RE_GENERATE_SUMMARY_FAIL]: (state, action) => {
      return {
        ...state,
        summaryFetching: false,
      }
    },
  },
  {
    fetching: false,
    summaryFetching: false,
    summaryFetched: false,
    summary: "",
    data: {},
    mappingData: {},
    isOpen: false,
    resumeId: null,
    builderId: null,
    reGenerationsLeft: 2,
    showEditText: false,
    logosUpdated: false,
  }
)

export default candidateDetails
